<template>
  <div>
    <span class="font-weight-bold block-title">{{ block.name }}</span>

    <v-expansion-panels v-model="open" :class="[{'circuit': block.isCircuit}, 'block-wrapper p-2']">
      <v-expansion-panel>
        <v-expansion-panel-header v-if="block.isCircuit" class="px-0 d-flex block-header">
          <div>Circuit</div>
          
          <v-spacer />
          <v-spacer />
          <v-spacer />

          <div class="d-flex">
            <p class="m-0 ml-5">
              Nombre d'exercices : {{ block.exercisesSets.length }}
            </p>
            
            <p class="m-0 ml-5">
              Tours : 

              <button
                v-for="(item, index) in block.nbRep"
                :class="[{'active': index <= round}, 'button-block-rep']"
                @click="(e) => changeRound(e, index)"
              />
            </p>

            <p class="m-0 ml-5">
              Récup {{ block.tpsRecup | readableTime }}
            </p>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="block-panel-content">
          <v-card class="mt-1" style="background: #F1F1F1">
            <v-expansion-panels v-for="(exerciseSet) in block.exercisesSets" v-bind:key="exerciseSet.id" class="p-2">
              <template v-if="exerciseSet.exerciseId">
                <exercise :exerciseSet="exerciseSet" />
              </template>

              <template v-if="exerciseSet.ppgExerciseId">
                <ppg-exercise-view :exerciseSet="exerciseSet" :ppgExercise="exerciseSet.ppgExercise" />
              </template>
            </v-expansion-panels>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import Exercise from "./exercise";
  import PpgExerciseView from "@/components/PpgExerciseView";
  import dayjs from "dayjs";

  export default {
    name: "block",

    props: {
      block: [Object],
    },

    components: {
      PpgExerciseView,
      Exercise,
    },

    data() {
      return {
        open: 0,
        round: 0,
      }
    },

    methods: {
      changeRound: function(e, round) {
        e.stopPropagation();
        this.round = round;
      }
    }
  }
</script>

<style>
  .block-header {
    color: #fff !important;
    font-size: 20px;
    font-weight: bold;
  }

  .block-header p:not(:last-child) {
    padding-right: 20px;
    border-right: 1px solid #FFF;
  }

  .block-panel-content .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }

  .block-wrapper > .v-expansion-panel {
    background: none !important;
  }

  .block-wrapper > .v-expansion-panel:before {
    box-shadow: none;
  }

  .button-block-rep {
    width: 16px;
    height: 16px;
    border-radius: 20px;
    border: 1px solid #ccc;
    background: #fff;
    margin-right: 5px;
  }

  .button-block-rep.active {
    background: #666;
  }
</style>